import React, { useState, useEffect} from "react";
import TransactionFlowDefaultTemplate from "../others/transactionFlowDefaultTemplate";
import { useSelector } from "react-redux";
import { RootState } from "../../store/store";
import supplierApis from "../../api/master/supplier";
import misc from "../../api/misc/dropDowns";
function StockAvailabilityReport() {
  const [siteOptions, setSiteOptions] = useState<any>([]);
  const [categoryOptions, setCategoryOptions] = useState<any>([]);
  const [materialOptions, setMaterialOptions] = useState<any>([]);
  const { data: currentUser } = useSelector(
    (state: RootState) => state.currentUser
  );
  const columns=[
    {
      title: "#",
      key: "#",
      width: 50,
      render: (text: any, record: any, index: any) => index + 1,
      sorter: true,
    },
    {
      title: "Site",
      dataIndex: "siteName",
      key: "siteName",
      width: 200,
    },
    {
      title: "Material Category",
      dataIndex: "categoryName",
      key: "categoryName",
      sorter: true,
      width: 200,
    },
    {
      title: "Material Name",
      dataIndex: "materialName",
      key: "materialName",
      sorter: true,
      width: 200,
    },
    {
      title: "UOM",
      dataIndex: "primaryUomName",
      key: "primaryUomName",
      sorter: true,
      width: 200,
    },
    {
      title: "Qty Available For Utilization",
      dataIndex: "quantityAvailable",
      key: "quantityAvailable",
      sorter: true,
      width: 200,
      render: (text: number, record: any) => (
        <div>
          <span>{text.toLocaleString("en-IN")}</span>
        </div>
      ),
    },
  ]

  useEffect(() => {
    fetchCategoryFilter();
    fetchMaterialFilter();
    if (currentUser) {
      const { siteAccessibility } = currentUser;
      if (siteAccessibility) {
        const options = currentUser.siteAccessibility.map((item: any) => ({
          label: item.siteName,
          value: item.siteID,
        }));
        setSiteOptions(options);
      }
    }
  }, [currentUser]);

  const fetchCategoryFilter = async () => {
    try {
      const { data, status } = await supplierApis.fetchSupplierCategory();
      if (status) {
        let _categoryOptions: any = [];
        let allCategory: any = [];
        data.forEach((item: any) => {
          allCategory.push(item?.id?.toString());
          _categoryOptions.push({
            label: item?.category,
            value: item?.id?.toString(),
          });
        });
        // setValue("category", allCategory?.join(","));
        if (_categoryOptions.length > 1) {
          _categoryOptions = [
            // {
            //   label: "ALL",
            //   value: allCategory?.join(","),
            // },
            ..._categoryOptions,
          ];
        }
        setCategoryOptions(_categoryOptions);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchMaterialFilter = async () => {
    try {
      const { data, status } = await misc.fetchProductFiltered();
      if (status) {
        const _materialOptions = data.map((item: any) => ({
          label: item?.productName,
          value: item?.materialID?.toString(),
        }));
        setMaterialOptions(_materialOptions);
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <TransactionFlowDefaultTemplate
      moduleKey="stock-availability"
      title="Stock Availability Report"
      columns={columns}
      selectFilters={[
        {
          title: "Site",
          placeholder: "Select Site",
          options: siteOptions,
          selectionMode: "multiple",
        },
        {
          title: "Category",
          placeholder: "Select Category",
          options: categoryOptions,
          selectionMode: "multiple",
        },
        {
          title: "Material",
          placeholder: "Select Material",
          options: materialOptions,
          selectionMode: "multiple",
        },
      ]}
      extra={{
        tableScrollX: 1100,
        dateRange: false,
        excelExport: true,
        dataFilterTootip: "Filtering based on quotation creation date",
      }}
    />
  );
}

export default StockAvailabilityReport;
